const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://j7h7n3a4ac.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://q4jpwqbfi2.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'taxonomy-teams-1.15.5',
    HOSTNAME: 'https://teams-service.valeglobal.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://opv2fciaaf.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;
